"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ListingImageV = _interopRequireDefault(require("../elements-image/ListingImageV2"));
var _avatar = require("../shared-components/image/avatar");
var _reactLazyload = _interopRequireDefault(require("react-lazyload"));
var _lodash = require("lodash");
var _placeholderImg = _interopRequireDefault(require("../elements-image/placeholderImg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Testimonial = function Testimonial(_ref) {
  var _ref$sectionTitle = _ref.sectionTitle,
    sectionTitle = _ref$sectionTitle === void 0 ? '' : _ref$sectionTitle,
    _ref$sectionDescripti = _ref.sectionDescription,
    sectionDescription = _ref$sectionDescripti === void 0 ? '' : _ref$sectionDescripti,
    _ref$sectionSubtitle = _ref.sectionSubtitle1,
    sectionSubtitle1 = _ref$sectionSubtitle === void 0 ? '' : _ref$sectionSubtitle,
    _ref$sectionSubtitle2 = _ref.sectionSubtitle2,
    sectionSubtitle2 = _ref$sectionSubtitle2 === void 0 ? '' : _ref$sectionSubtitle2,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items;
  var imageDetails = (0, _lodash.get)(items, '0', {});
  var _imageDetails$content = imageDetails.contentCloudinaryId,
    contentCloudinaryId = _imageDetails$content === void 0 ? '' : _imageDetails$content,
    _imageDetails$imageAl = imageDetails.imageAltText,
    imageAltText = _imageDetails$imageAl === void 0 ? '' : _imageDetails$imageAl;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "Testimonial"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/_react.default.createElement("h4", null, sectionTitle))), /*#__PURE__*/_react.default.createElement("div", {
    className: "testimonial-border flex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "testimonial-image",
    className: "testimonial-image flex-basis-40"
  }, /*#__PURE__*/_react.default.createElement(_reactLazyload.default, {
    offset: 100,
    placeholder: _placeholderImg.default,
    once: true
  }, /*#__PURE__*/_react.default.createElement(_ListingImageV.default, {
    sizes: '(min-width: 768px) 50vw, 300px',
    imgId: contentCloudinaryId,
    alt: imageAltText,
    ratio: 1,
    widths: ['320', '640', '960', '1280'],
    className: ""
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "quote flex-basis-60"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "quote-image"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "/web-templates/assets/images/quote_mark.svg?v=rb"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "quote-text"
  }, sectionDescription), /*#__PURE__*/_react.default.createElement("div", {
    className: "quote-author flex"
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_avatar.Avatar, {
    className: "author-avatar",
    src: "https://img.peerspace.com/image/upload/c_crop,g_custom/g_auto,q_auto,f_auto,fl_progressive/c_fill,w_100,h_100/".concat(contentCloudinaryId)
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "author-line flex top"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    width: "25",
    height: "1",
    viewBox: "0 0 25 1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("line", {
    y1: "0.5",
    x2: "24.1302",
    y2: "0.5",
    stroke: "black"
  }))), /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "heavy"
  }, sectionSubtitle1), /*#__PURE__*/_react.default.createElement("div", {
    className: "text-small text-gray-600"
  }, sectionSubtitle2)))))));
};
Testimonial.propTypes = {
  sectionTitle: _propTypes.default.string,
  sectionDescription: _propTypes.default.string,
  sectionSubtitle1: _propTypes.default.string,
  sectionSubtitle2: _propTypes.default.string,
  items: _propTypes.default.array
};
var _default = exports.default = Testimonial;